import { create } from 'zustand'

interface ModalTermsConditionsState {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const initialState = {
  isOpen: false
}

export const useModalTermsConditionsStore = create<ModalTermsConditionsState>()(
  (set) => ({
    ...initialState,
    setIsOpen: (isOpen) => set({ isOpen })
  })
)
